import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "document-details-container",
  class: "p-d-flex p-flex-column kn-flex kn-height-full"
}
const _hoisted_2 = { class: "document-details-tab-container p-d-flex p-flex-column kn-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_InformationsTab = _resolveComponent("InformationsTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_Badge = _resolveComponent("Badge")
  const _component_DriversTab = _resolveComponent("DriversTab")
  const _component_OutputParamsTab = _resolveComponent("OutputParamsTab")
  const _component_DataLineageTab = _resolveComponent("DataLineageTab")
  const _component_HistoryTab = _resolveComponent("HistoryTab")
  const _component_SubreportsTab = _resolveComponent("SubreportsTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_DocumentDetailOlapDesignerDialog = _resolveComponent("DocumentDetailOlapDesignerDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_ctx.viewMode === 'document-detail' || _ctx.$route.name === 'document-details-new-document' || _ctx.$route.name === 'document-details-edit-document')
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.title')), 1)
          ]),
          end: _withCtx(() => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-save",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.saveDocument,
              disabled: _ctx.invalidDrivers > 0 || _ctx.invalidOutputParams > 0 || _ctx.invalidFunctionalities == 0 || _ctx.v$.$invalid
            }, null, 8, ["onClick", "disabled"]), [
              [
                _directive_tooltip,
                _ctx.$t('common.save'),
                void 0,
                { bottom: true }
              ]
            ]),
            (_ctx.propMode === 'execution')
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "pi pi-times",
                  class: "p-button-text p-button-rounded p-button-plain",
                  onClick: _ctx.closeDocument
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _ctx.$t('common.close'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
              key: 0,
              class: "doc-details-spinner",
              style: _ctx.mainDescriptor.style.spinnerStyle
            }, null, 8, ["style"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_TabView, {
            class: "document-details-tabview p-d-flex p-flex-column kn-flex",
            onTabChange: _ctx.onTabChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TabPanel, null, {
                header: _withCtx(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.infoTitle')), 1)
                ]),
                default: _withCtx(() => [
                  (!_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_InformationsTab, {
                        key: 0,
                        selectedDocument: _ctx.selectedDocument,
                        availableFolders: _ctx.availableFolders,
                        documentTypes: _ctx.types,
                        documentEngines: _ctx.engines,
                        availableDatasources: _ctx.dataSources,
                        availableStates: _ctx.states,
                        selectedDataset: _ctx.selectedDataset,
                        availableTemplates: _ctx.templates,
                        availableAttributes: _ctx.attributes,
                        onSetTemplateForUpload: _ctx.setTemplateForUpload,
                        onSetImageForUpload: _ctx.setImageForUpload,
                        onDeleteImage: _ctx.deleteImage,
                        onOpenDesignerDialog: _ctx.openDesignerDialog
                      }, null, 8, ["selectedDocument", "availableFolders", "documentTypes", "documentEngines", "availableDatasources", "availableStates", "selectedDataset", "availableTemplates", "availableAttributes", "onSetTemplateForUpload", "onSetImageForUpload", "onDeleteImage", "onOpenDesignerDialog"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (this.selectedDocument?.id)
                ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                    header: _withCtx(() => [
                      _createVNode("span", {
                        class: { 'details-warning-color': _ctx.invalidDrivers }
                      }, _toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.title')), 3),
                      (_ctx.invalidDrivers > 0)
                        ? (_openBlock(), _createBlock(_component_Badge, {
                            key: 0,
                            value: _ctx.invalidDrivers,
                            class: "p-ml-2",
                            severity: "danger"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_DriversTab, {
                        selectedDocument: _ctx.selectedDocument,
                        availableDrivers: _ctx.drivers,
                        availableAnalyticalDrivers: _ctx.analyticalDrivers
                      }, null, 8, ["selectedDocument", "availableDrivers", "availableAnalyticalDrivers"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (this.selectedDocument?.id)
                ? (_openBlock(), _createBlock(_component_TabPanel, { key: 1 }, {
                    header: _withCtx(() => [
                      _createVNode("span", {
                        class: { 'details-warning-color': _ctx.invalidOutputParams }
                      }, _toDisplayString(_ctx.$t('documentExecution.documentDetails.outputParams.title')), 3),
                      (_ctx.invalidOutputParams > 0)
                        ? (_openBlock(), _createBlock(_component_Badge, {
                            key: 0,
                            value: _ctx.invalidOutputParams,
                            class: "p-ml-2",
                            severity: "danger"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_OutputParamsTab, {
                        selectedDocument: _ctx.selectedDocument,
                        typeList: _ctx.parTypes,
                        dateFormats: _ctx.dateFormats
                      }, null, 8, ["selectedDocument", "typeList", "dateFormats"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (this.selectedDocument?.id && _ctx.showDataLineageTab)
                ? (_openBlock(), _createBlock(_component_TabPanel, { key: 2 }, {
                    header: _withCtx(() => [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('documentExecution.documentDetails.dataLineage.title')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_DataLineageTab, {
                        selectedDocument: _ctx.selectedDocument,
                        metaSourceResource: _ctx.metaSourceResource,
                        savedTables: _ctx.savedTables
                      }, null, 8, ["selectedDocument", "metaSourceResource", "savedTables"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (this.selectedDocument?.id)
                ? (_openBlock(), _createBlock(_component_TabPanel, { key: 3 }, {
                    header: _withCtx(() => [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('documentExecution.documentDetails.history.title')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_HistoryTab, {
                        selectedDocument: _ctx.selectedDocument,
                        onOpenDesignerDialog: _ctx.openDesignerDialog
                      }, null, 8, ["selectedDocument", "onOpenDesignerDialog"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (this.selectedDocument?.id && this.selectedDocument?.typeCode == 'REPORT' && this.selectedDocument?.engine == 'knowagejasperreporte')
                ? (_openBlock(), _createBlock(_component_TabPanel, { key: 4 }, {
                    header: _withCtx(() => [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('documentExecution.documentDetails.subreports.title')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_SubreportsTab, {
                        selectedDocument: _ctx.selectedDocument,
                        allDocumentDetailsProp: _ctx.allDocumentDetails
                      }, null, 8, ["selectedDocument", "allDocumentDetailsProp"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onTabChange"])
        ]),
        (_ctx.designerDialogVisible)
          ? (_openBlock(), _createBlock(_component_DocumentDetailOlapDesignerDialog, {
              key: 1,
              visible: _ctx.designerDialogVisible,
              selectedDocument: _ctx.selectedDocument,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.designerDialogVisible = false)),
              onDesignerStarted: _ctx.onDesignerStart
            }, null, 8, ["visible", "selectedDocument", "onDesignerStarted"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}